module.exports = __webpack_public_path__ + "img/ry4.80dcec86.svg";